import { Box, Tooltip } from '@mui/material';
import cn from 'classnames';
import * as React from 'react';

import { capitalize } from '../../utils/ui';

import styles from './IntegrationItem.module.scss';

interface IProps {
  className?: string;
  active?: boolean;
  onClick?: () => any;
  icon?: React.ReactNode;
  name?: string;
}

const IntegrationItem = ({ className, active, onClick, icon, name }: IProps) => {
  const tooltipText = `${capitalize(name || 'integration')} is ${active ? '' : 'not '}integrated`;

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <Box
        className={cn(className, styles.integrationItem, { [styles.active]: active })}
        style={{ backgroundImage: `url(${icon})` }}
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default IntegrationItem;
